let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eioKP")).then(() => parcelRequire('6Ivy0'));